module.exports = __webpack_public_path__ + "static/media/img-moduleB3.b043e13f.png";